import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Input, Select, Form, message } from "antd";
import dataService from "../networks/api/service/dataService";
import DynamicExcelUpload from "../components/DynamicExcelUpload";
import * as XLSX from "xlsx";
import { DownloadOutlined } from "@ant-design/icons";
import CustomTable from "../components/TableComponent/CustomTable";
import CustomModal from "../components/MODAL/CustomModal";
import PrimaryButton from "../components/TableComponent/ButtonComponent/Buttons";
import UploadButton from "../components/TableComponent/ButtonComponent/UploadButton";
import DownloadButton from "../components/TableComponent/ButtonComponent/DownloadButton";

function ConstituencyList() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [adminOptions, setAdminOptions] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [form] = Form.useForm();

  const getExcelData = async (formData) => {
    console.log(formData, "getExcelData");
    try {
      const res = await dataService.uploadBulkConstituency(formData);
      if (res.code === 200) {
        getConstituency();
      }
    } catch (e) {}
  };

  const columns = [
    {
      title: "Parliament Name",
      dataIndex: "constituencyName",
      key: "constituencyName",
    },
    {
      title: "Admin Name",
      dataIndex: "adminName",
      key: "adminName",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button type="link" onClick={() => handleEdit(record)}>
          Edit
        </Button>
      ),
    },
  ];


  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditingRecord(record);
    form.setFieldsValue(record);
    showModal();
  };

  //   // Download sample Excel file
  const downloadSampleFile = () => {
    const worksheet = XLSX.utils.json_to_sheet([
      { "Sl NO": "", CONSTITUENCY: "" },
    ]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Constituency_Sample");
    XLSX.writeFile(workbook, "Constituency_Sample.xlsx");
  };

  const saveConstituency = async (payload) => {
    try {
      if (editingRecord) {
        await dataService.editConstituency(editingRecord._id, payload);
        message.success("Constituency updated successfully");
      } else {
        await dataService.addConstituency(payload);
        message.success("Constituency added successfully");
      }
      getConstituency();
    } catch (e) {
      message.error("Failed to save Constituency");
    }
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const selectedAdmin = adminOptions.find(admin => admin._id === values.adminId);
        const payload = {
          constituencyName: values.constituencyName,
          adminId: values.adminId,
          adminName: selectedAdmin ? selectedAdmin.name : "",
        };
        saveConstituency(payload);
        form.resetFields();
        setIsModalVisible(false);
        setEditingRecord(null);
      })
      .catch((info) => {
        console.log("Validation failed:", info);
      });
  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalVisible(false);
    setEditingRecord(null);
  };

  const getConstituency = async () => {
    try {
      const res = await dataService.getAllConstituency();
      if (res.code === 200) {
        const updatedData = res.data.map(item => ({
          ...item,
          adminName: adminOptions.find(admin => admin._id === item.adminId)?.name || "",
        }));
        setData(updatedData);
        setFilteredData(updatedData);
      }
    } catch (e) {}
  };

  const getAdmin = async () => {
    try {
      const res = await dataService.getAdminForPanchayat("CONSTITUENCY");
      if (res.code === 200) {
        setAdminOptions(res.data);
      }
    } catch (e) {}
  };

  useEffect(() => {
    getConstituency();
    getAdmin();
  }, []);

  useEffect(() => {
    if (adminOptions.length > 0) {
      getConstituency();
    }
  }, [adminOptions]);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    const filtered = data.filter((item) =>
      item?.constituencyName?.toLowerCase()?.includes(value)
    );
    setFilteredData(filtered);
  };

  return (
    <div>
      <h2>Parliament List</h2>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 20,
        }}
      >
        <Button
          type="primary"
          onClick={() => {
            setEditingRecord(null);
            showModal();
          }}
        >
          Add Parliament
        </Button>
        <Input.Search
          placeholder="Search by Parliament Name"
          onChange={handleSearch}
          style={{ width: 200 }}
        />
      </div>

      <CustomTable
        dataSource={filteredData}
        columns={columns}
        rowKey={(record) => record._id}
        bordered
        pagination={true}
        size="middle"
        style={{
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          backgroundColor: "#fff",
          width: "100%",
          overflowX: "auto",
        }}
        scroll={{ x: 800 }}
      />

      <div style={{ marginTop: 20 }}>
        <h3>Bulk Upload</h3>
        <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
          <DownloadButton onClick={downloadSampleFile}>
            Download Sample File
          </DownloadButton>
        </div>
        <DynamicExcelUpload getExcelData={getExcelData} />
      </div>
      <Modal
        title={editingRecord ? "Edit Parliament" : "Add Parliament"}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Save"
        cancelText="Cancel"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="Parliament Name"
            name="constituencyName"
            rules={[
              { required: true, message: "Please enter Parliament Name" },
              { pattern: /^[A-Za-z\s]+$/, message: "Only letters and spaces are allowed" }
            ]}
          >
            <Input placeholder="Enter Parliament Name" />
          </Form.Item>

          <Form.Item
            label="Admin"
            name="adminId"
            rules={[{ required: true, message: "Please select an Admin" }]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              placeholder="Select Admin"
              style={{ border: "1px solid grey", borderRadius: 5 }}
            >
              {adminOptions.map((admin) => (
                <Select.Option key={admin._id} value={admin._id}>
                  {admin.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default ConstituencyList;
